import { apiClient } from '../../../../core/api/client';
import {
  NoticeListResponse,
  NoticeDetailResponse,
  NoticeActionResponse,
  CreateNoticeRequest,
  UpdateNoticeRequest,
} from '../types/notice.types';

// 포털용 API (관리자/협력사 웹용)
const PORTAL_BASE_URL = '/api/v1/portal/notice';
// 모바일용 API (라이더 앱용)
const MOBILE_BASE_URL = '/api/v1/mob/notice';

// 기존 호환성 유지
const BASE_URL = PORTAL_BASE_URL;

/**
 * 공지사항 목록 조회
 * - 본사: 전체 공지 조회
 * - 협력사: 본인이 작성한 공지만 조회
 */
export const getNoticeList = async (): Promise<NoticeListResponse> => {
  const response = await apiClient.get<NoticeListResponse>(`${BASE_URL}/list`);
  return response.data;
};

/**
 * 공지사항 상세 조회
 */
export const getNoticeDetail = async (noticeId: number): Promise<NoticeDetailResponse> => {
  const response = await apiClient.get<NoticeDetailResponse>(`${BASE_URL}/${noticeId}`);
  return response.data;
};

/**
 * 공지사항 등록
 */
export const createNotice = async (data: CreateNoticeRequest): Promise<NoticeActionResponse> => {
  const response = await apiClient.post<NoticeActionResponse>(`${BASE_URL}/create`, data);
  return response.data;
};

/**
 * 공지사항 수정
 */
export const updateNotice = async (data: UpdateNoticeRequest): Promise<NoticeActionResponse> => {
  const response = await apiClient.post<NoticeActionResponse>(`${BASE_URL}/update`, data);
  return response.data;
};

/**
 * 공지사항 삭제
 */
export const deleteNotice = async (noticeId: number): Promise<NoticeActionResponse> => {
  const response = await apiClient.delete<NoticeActionResponse>(`${BASE_URL}/${noticeId}`);
  return response.data;
};

/**
 * 공지사항 읽음 처리
 */
export const markNoticeAsRead = async (noticeId: number): Promise<NoticeActionResponse> => {
  const response = await apiClient.post<NoticeActionResponse>(`${BASE_URL}/${noticeId}/read`);
  return response.data;
};

/**
 * 읽지 않은 팝업 공지 조회 (협력사용)
 */
export const getUnreadPopupNotices = async (): Promise<NoticeListResponse> => {
  const response = await apiClient.get<NoticeListResponse>(`${BASE_URL}/popup`);
  return response.data;
};

/**
 * 나에게 온 공지 조회 (협력사용)
 */
export const getMyNotices = async (): Promise<NoticeListResponse> => {
  const response = await apiClient.get<NoticeListResponse>(`${BASE_URL}/my`);
  return response.data;
};

// ==================== 모바일(라이더) 전용 API ====================

/**
 * 라이더용 공지 목록 조회
 */
export const getMobileNoticeList = async (): Promise<NoticeListResponse> => {
  const response = await apiClient.get<NoticeListResponse>(`${MOBILE_BASE_URL}/list`);
  return response.data;
};

/**
 * 라이더용 읽지 않은 팝업 공지 조회
 */
export const getMobileUnreadPopupNotices = async (): Promise<NoticeListResponse> => {
  const response = await apiClient.get<NoticeListResponse>(`${MOBILE_BASE_URL}/popup`);
  return response.data;
};

/**
 * 라이더용 공지 읽음 처리
 */
export const markMobileNoticeAsRead = async (noticeId: number): Promise<NoticeActionResponse> => {
  const response = await apiClient.post<NoticeActionResponse>(`${MOBILE_BASE_URL}/${noticeId}/read`);
  return response.data;
};

/**
 * 라이더용 읽지 않은 공지 개수 조회
 */
export const getMobileUnreadCount = async (): Promise<number> => {
  const response = await apiClient.get<number>(`${MOBILE_BASE_URL}/unread-count`);
  return response.data;
};
